import React from "react";
import { useModal } from "../modal-context";
import { Button } from "@heroui/button";
import { useTranslations } from "next-intl";
export default function ComingSoonModal() {
  const { closeModal } = useModal();
  const t = useTranslations();
  return (
    <>
      <div className="flex w-full flex-col items-center justify-center p-5">
        <span className="icon-icon14 text-[5rem] text-white" />
        <h1 className="">{t("coming-soon")}</h1>
      </div>

      <Button className="bg-[#258966]" onPress={closeModal}>
        {t('ok')}
      </Button>
    </>
  );
}
